import { Deserializable } from './deserializable';
import { BaseModel } from './base.model';

export class BusinessunitModel extends BaseModel implements Deserializable {

  // columns
  name: string;

  // children
  businessunits: Array<BusinessunitModel>;

  deserialize(input: any): this {
    Object.assign(this, input);
    // businessunits
    if (this.businessunits !== null && this.businessunits !== undefined) {
      this.businessunits.map((businessunit: any) => {
        return new BusinessunitModel().deserialize(businessunit);
      }).sort((a: BusinessunitModel, b: BusinessunitModel) => {
        return (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0);
      });
    }
    this.loaded = true;
    return this;
  }

}
